
import React, { useEffect, useRef } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import { addMarkersToMap, LoginLocation } from './MapMarkers';

interface MapContainerProps {
  token: string;
  locations: LoginLocation[];
  onMarkersUpdate: (markers: mapboxgl.Marker[]) => void;
}

export const MapContainer = ({ token, locations, onMarkersUpdate }: MapContainerProps) => {
  const mapContainer = useRef<HTMLDivElement>(null);
  const map = useRef<mapboxgl.Map | null>(null);
  const markers = useRef<mapboxgl.Marker[]>([]);

  useEffect(() => {
    if (!mapContainer.current || !token) return;

    try {
      // تعيين رمز Mapbox 
      mapboxgl.accessToken = token;
      
      // تعيين الخريطة
      map.current = new mapboxgl.Map({
        container: mapContainer.current,
        style: 'mapbox://styles/mapbox/light-v11',
        center: [46.6753, 24.7136], // الرياض كنقطة مركزية
        zoom: 6
      });

      // إضافة أدوات التحكم في الخريطة
      map.current.addControl(new mapboxgl.NavigationControl(), 'top-right');
      
    } catch (error) {
      console.error('Error initializing map:', error);
    }

    return () => {
      map.current?.remove();
    };
  }, [token]);

  // إضافة الدبابيس عند تغير المواقع أو تحميل الخريطة
  useEffect(() => {
    if (!map.current || !locations.length) return;

    // التأكد من أن الخريطة مُحمّلة
    if (map.current.loaded()) {
      const newMarkers = addMarkersToMap(map.current, locations, markers.current);
      markers.current = newMarkers;
      onMarkersUpdate(newMarkers);
    } else {
      map.current.once('load', () => {
        if (map.current) {
          const newMarkers = addMarkersToMap(map.current, locations, markers.current);
          markers.current = newMarkers;
          onMarkersUpdate(newMarkers);
        }
      });
    }
  }, [locations, token, onMarkersUpdate]);

  return (
    <div 
      ref={mapContainer} 
      className="h-96 w-full rounded-lg border"
      style={{ minHeight: '400px' }}
    />
  );
};
